module.exports = __webpack_public_path__ + "img/ff35b3c.png";